/**
 * S&F Filter Accordion.
 *
 * @package
 * @since 1.0.0
 */

export const sfAccordions = () => {
	const sfFiltersForm = document.querySelector( '.searchandfilter' );

	if ( sfFiltersForm ) {
		// Set [aria-label] on filters to indicate results update on filter updates.
		sfFiltersForm.setAttribute(
			'aria-label',
			'Use of search, filters and sort by will update results automatically'
		);

		// Get search field and set [aria-label] to indicate results update on search.
		const sfSearchField = sfFiltersForm.querySelector(
			'.sf-field-search .sf-input-text'
		);
		if ( sfSearchField ) {
			sfSearchField.setAttribute(
				'aria-label',
				'Search and filters will update results automatically'
			);
		}

		// Get sort by field and set [aria-label] to indicate results update on search.
		const sfSortByField = sfFiltersForm.querySelector(
			'.sf-field-sort_order .sf-input-select'
		);
		if ( sfSortByField ) {
			sfSortByField.setAttribute(
				'aria-label',
				'Field will update results automatically'
			);
		}

		// Get all checkbox & radio filters.
		const sfFilters = sfFiltersForm.querySelectorAll(
			'[data-sf-field-input-type="checkbox"], [data-sf-field-input-type="range-checkbox"], [data-sf-field-input-type="radio"], [data-sf-field-input-type="range-radio"]'
		);

		// Loop through the filters and create accordions.
		if ( sfFilters.length > 0 ) {
			for ( let i = 0; i < sfFilters.length; i++ ) {
				// Create a new accordion trigger button element and append heading.
				const filterHeading = sfFilters[ i ].querySelector(
					'h4, .sf-field-heading'
				);
				const accordionButton = document.createElement( 'button' );
				accordionButton.setAttribute( 'type', 'button' );
				accordionButton.classList.add( 'sf-accordion-button' );
				accordionButton.appendChild( filterHeading );
				sfFilters[ i ].prepend( accordionButton );

				// Close Accordion on page load.
				closeAccordion( sfFilters[ i ], accordionButton );

				// Hide Accordion if empty on page load.
				hideEmptyAccordion( sfFilters[ i ] );

				// Toggle Accordion on click / key press.
				accordionButton.addEventListener( 'click', function () {
					toggleAccordion( sfFilters[ i ], accordionButton );
				} );
			}
		}

		// Mobile Functionality.
		// Check if mobile filter button already exists.
		const doesFiltersButtonExist =
			sfFiltersForm.querySelectorAll( '.js-filters-button' );

		// If not, add the mobile filter button.
		if ( doesFiltersButtonExist.length === 0 ) {
			let filtersButton =
				'<button class="sf-filters-button button js-filters-button" aria-expanded="false"><span>Filters</span></button>';
			sfFiltersForm.insertAdjacentHTML( 'afterbegin', filtersButton );
			filtersButton = document.querySelector( '.js-filters-button' );

			// Show/hide the filters on mobile filter button click.
			filtersButton.addEventListener(
				'click',
				function ( event ) {
					event.preventDefault();
					const list = sfFiltersForm.querySelector( 'ul' );

					// Toggle the mobile search accordion.
					sfFiltersForm.classList.toggle( 'toggled' );
					list.setAttribute(
						'aria-hidden',
						list.getAttribute( 'aria-hidden' ) === 'false'
							? 'true'
							: 'false'
					);
					filtersButton.setAttribute(
						'aria-expanded',
						filtersButton.getAttribute( 'aria-expanded' ) ===
							'false'
							? 'true'
							: 'false'
					);
				},
				false
			);
		}
	}
};

// Close Accordion.
// Close the accordion unless it has active filters.
export const closeAccordion = ( accordion, accordionButton ) => {
	const accordionFilters = accordion.querySelector( 'ul' );

	// If the accordion has an active filter, keep it open.
	if ( accordionFilters.querySelector( 'li.sf-option-active' ) ) {
		accordionButton.setAttribute( 'aria-expanded', 'true' );
		accordionFilters.setAttribute( 'aria-hidden', 'false' );
		return;
	}

	// Otherwise close the accordion.
	accordionButton.setAttribute( 'aria-expanded', 'false' );
	accordionFilters.setAttribute( 'aria-hidden', 'true' );
};

// Toggle Accordion (open/close).
// Toggle [aria-expanded] and [aria-hidden] values on accordion button and filters.
export const toggleAccordion = ( accordion, accordionButton ) => {
	const accordionFilters = accordion.querySelector( 'ul' );

	if ( accordionFilters ) {
		// Update the accordion button.
		accordionButton.setAttribute(
			'aria-expanded',
			accordionButton.getAttribute( 'aria-expanded' ) === 'false'
				? 'true'
				: 'false'
		);

		// Update the accordion filters.
		accordionFilters.setAttribute(
			'aria-hidden',
			accordionFilters.getAttribute( 'aria-hidden' ) === 'false'
				? 'true'
				: 'false'
		);
	}
};

// Hide Empty Accordion.
// If the accordion has no possible filters, hide it.
export const hideEmptyAccordion = ( accordion ) => {
	const accordionFilters = accordion.querySelector( 'ul' ).children;

	if ( accordionFilters.length === 0 ) {
		accordion.setAttribute( 'style', 'display:none;' );
	} else {
		accordion.removeAttribute( 'style' );
	}
};
